// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"MenuItem_linkWrapper__2cU59","iconWrapper":"MenuItem_iconWrapper__2iYnb","linkText":"MenuItem_linkText__1c7E5","linkActive":"MenuItem_linkActive__K79_n"};